import React, {useState} from 'react';
import Importance from './Importance';
import PlanAdditional from './PlanAdditional';
import PlanStudy from './PlanStudy';
import {Link} from 'react-router-dom';

const LessonPlanPage3 = () => {
  return (
    <div className="text-center">
      <div className="font-5 fw-bold mb-4">Времена глаголов</div>
      <div className="row justify-content-evenly gx-lg-4 gy-4">
        <div className="col-lg-3">
          <div className="font-4 fw-bold mb-3">Прошедшее</div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[26, 27]} />
            <div>Очевидное прошедшее время</div>
            <PlanAdditional
              levels={
                <div className="mt-3 text-start font-2">
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/26/grammar">Очевидное прошедшее время</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[26]} notAbsolute />
                    </span>
                  </div>
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/27/grammar">Отрицательная и вопросительная форма</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[27]} notAbsolute />
                    </span>
                  </div>
                </div>
              }
            />
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={3} />
            <PlanStudy levels={[61]} />
            <Link to="/my-lessons/61/grammar">Сомнительное прошедшее время</Link>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={3} />
            <PlanStudy levels={[62]} />
            <Link to="/my-lessons/62/grammar">Давно прошедшее время</Link>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={2} />
            <PlanStudy levels={[63]} />
            <Link to="/my-lessons/63/grammar">Переходное прошедшее время</Link>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="font-4 fw-bold mb-3">Настоящее</div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[28, 29, 30]} />
            <div>Собственное настоящее время</div>
            <PlanAdditional
              levels={
                <div className="mt-3 text-start font-2">
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/28/grammar">Простая форма</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[28]} notAbsolute />
                    </span>
                  </div>
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/29/grammar">Сложная форма</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[29]} notAbsolute />
                    </span>
                  </div>
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/30/grammar">Отрицательная и вопросительная форма</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[30]} notAbsolute />
                    </span>
                  </div>
                </div>
              }
            />
          </div>
          <div className="border bg-white px-2 py-3 mb-3 mt-5 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[46]} />
            <Link to="/my-lessons/46/grammar">Настоящее намеренное время</Link>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="font-4 fw-bold mb-3">Будущее</div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative me-4">
            <Importance stars={5} />
            <PlanStudy levels={[31, 32]} />
            <div>Будущее переходное время</div>
            <PlanAdditional
              levels={
                <div className="mt-3 text-start font-2">
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/31/grammar">Будущее переходное время</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[31]} notAbsolute />
                    </span>
                  </div>
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/32/grammar">Отрицательная и вопросительная форма</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[32]} notAbsolute />
                    </span>
                  </div>
                </div>
              }
            />
          </div>
          <div className="border bg-white px-2 py-3 mb-3 mt-5 position-relative">
            <Importance stars={3} />
            <PlanStudy levels={[59, 60]} />
            <div className="text-center">Будущее предположительное время</div>
            <PlanAdditional
              levels={
                <div className="mt-3 text-start font-2">
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/59/grammar">Будущее предположительное время</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[59]} notAbsolute />
                    </span>
                  </div>
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/60/grammar">Отрицательная форма</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[60]} notAbsolute />
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LessonPlanPage3;
